import { environment } from 'src/environments/environment';
import { TokenService } from './token.service';

export function storeRegionTokens(
  tokenService: TokenService,
  regionTokens: any,
  email: string
): void {
  if (!email || !regionTokens) return;

  const { drRegion, drRegionSecondary } = environment;
  let primaryToken = regionTokens.find((r: any) => r.name === drRegion);
  let secondaryToken = regionTokens.find(
    (r: any) => r.name === drRegionSecondary
  );

  if (!primaryToken || !primaryToken.success) {
    console.warn(
      `Primary region (${drRegion}) token not available, checking secondary`
    );
    if (secondaryToken && secondaryToken.success) {
      // Swap: use secondary as primary if primary is not available
      primaryToken = secondaryToken;
      secondaryToken = null;
    }
  }

  tokenService.setTokens(primaryToken, secondaryToken, email);
}
